const Aguascalientes = {
  parties: [
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Aguascalientes',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'María Teresa Jiménez Esquivel',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PAN, PRD y PRI',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/maria-teresa-jimenez-esquivel.png',
        },
      ],
      block: 'PAN, PRD y PRI',
      settings: {
        color: '#1400A9',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia por Aguascalientes',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Martha Cecilia Márquez Alvarado',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PVEM y PT',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/martha-cecilia-marquez-alvarado.png',
        },
      ],
      block: 'PVEM y PT',
      settings: {
        color: '#CC850D',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
    {
      party_id: '5',
      votes: 0,
      votes_percent: 0.0,
      name: 'Fuerza por México',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Natzielly Teresita Rodríguez Calzada',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Fuerza por México',
          avatar:
            'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/natzielly-teresita-rodriguez-calzada.png',
        },
      ],
      block: 'Fuerza por México',
      settings: {
        color: '#F51F8C',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
    {
      party_id: '4',
      votes: 0,
      votes_percent: 0.0,
      name: 'Morena',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Nora Ruvalcaba Gámez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/nora-ruvalcaba-gamez.png',
        },
      ],
      block: 'Morena',
      settings: {
        color: '#7B0000',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Anayeli Muñoz Moreno',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/anayeli-munoz-moreno.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:aguascalientes:locales:governors:2022',
    },
  ],
};
//
//
//
//
//
//
//
//
//
//

const Durango = {
  parties: [
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Alma Marina Vitela Rodríguez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena, PT, PVEM y RSP',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/alma-marina-vitela-rodriguez.png',
        },
      ],
      block: 'Morena, PT, PVEM y RSP',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:durango:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Durango',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Esteban Alejandro Villegas Villarreal',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PRI, PAN y PRD',
          avatar:
            'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/esteban-alejandro-villegas-villarreal.png',
        },
      ],
      block: 'PRI, PAN y PRD',
      settings: {
        color: '#3b83bd',
      },
      election_key: 'infobae.com:mexico:durango:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Patricia Flores Elizondo',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/patricia-flores-elizondo.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#FF8300',
      },
      election_key: 'infobae.com:mexico:durango:locales:governors:2022',
    },
  ],
};
//
//
//
//
//
//
//
//
//

const Hidalgo = {
  parties: [
    {
      party_id: '4',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia en Hidalgo',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Julio Ramón Menchaca Salazar',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Juntos Hacemos Historia en Hidalgo',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/julio-ramon-menchaca-salazar.png',
        },
      ],
      block: 'Juntos Hacemos Historia en Hidalgo',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:hidalgo:locales:governors:2022',
    },
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Hidalgo',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Alma Carolina Viggiano Austria',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Va por Hidalgo',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/alma-carolina-viggiano-austria.png',
        },
      ],
      block: 'Va por Hidalgo',
      settings: {
        color: '#3b83bd',
      },
      election_key: 'infobae.com:mexico:hidalgo:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Francisco Xavier Berganza Escorza',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar:
            'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/francisco-xavier-berganza-escorza.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:hidalgo:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Partido Verde',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'José Luis Lima Morales',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Partido Verde',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/jose-luis-lima-morales.png',
        },
      ],
      block: 'Partido Verde',
      settings: {
        color: '#00A929',
      },
      election_key: 'infobae.com:mexico:hidalgo:locales:governors:2022',
    },
  ],
};
//
//
//
//
//
//
//
//
//

const Oaxaca = {
  parties: [
    {
      party_id: '7',
      votes: 0,
      votes_percent: 0.0,
      name: 'PRI y PRD',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Alejandro Áviles Álvarez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PRI y PRD',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/alejandro-aviles-alvarez.png',
        },
      ],
      block: 'PRI y PRD',
      settings: {
        color: '#E40000',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '6',
      votes: 0,
      votes_percent: 0.0,
      name: 'Candidato Independiente',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Jesús López Rodríguez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Candidato Independiente',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/jesus-lopez-rodriguez.png',
        },
      ],
      block: 'Candidato Independiente',
      settings: {
        color: '#004E1D',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '5',
      votes: 0,
      votes_percent: 0.0,
      name: 'Candidato Independiente',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Mauricio Cruz Vargas',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Candidato Independiente',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/mauricio-cruz-vargas.png',
        },
      ],
      block: 'Candidato Independiente',
      settings: {
        color: '#004E1D',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '4',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia en Oaxca',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Salomón Jara Cruz',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena, PT, PVEM y Partido Unidad Popular',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/salomon-jara-cruz.png',
        },
      ],
      block: 'Morena, PT, PVEM y Partido Unidad Popular',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Partido Nueva Alianza',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Bersahín Asael López López',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Partido Nueva Alianza',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/bersahin-asael-lopez-lopez.png',
        },
      ],
      block: 'Partido Nueva Alianza',
      settings: {
        color: '#00A6AD',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Dulce Alejandra García Morlan',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/dulce-alejandra-garcia-morlan.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Partido Acción Nacional',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Antonia Natividad Díaz Jiménez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Partido Acción Nacional',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/antonia-natividad-diaz-jimenez.png',
        },
      ],
      block: 'Partido Acción Nacional',
      settings: {
        color: '#1400A9',
      },
      election_key: 'infobae.com:mexico:oaxaca:locales:governors:2022',
    },
  ],
};
//
//
//
//
//
//
//
//
//

const Quintana = {
  parties: [
    {
      party_id: '5',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Quintana Roo',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Laura Lynn Fernández Piña',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PAN y PRD',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/laura-lynn-fernandez-pina.png',
        },
      ],
      block: 'PAN y PRD',
      settings: {
        color: '#06318A',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
    {
      party_id: '4',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Haremos Historia en Quintana Roo',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'María Elena Hermelinda Lezama Espinosa',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena, PT, PVEM, Fuerza por México',
          avatar:
            'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/maria-elena-hermelinda-lezama-espinosa.png',
        },
      ],
      block: 'Morena, PT, PVEM, Fuerza por México',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Auténtico Social',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Josúe Nivardo Mena Villanueva',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Auténtico Social',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/josue-nivardo-mena-villanueva.png',
        },
      ],
      block: 'Movimiento Auténtico Social',
      settings: {
        color: '#682676',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'José Luis Pech Várguez',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/jose-luis-pech-varguez.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'PRI',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Leslie Angelina Hendricks Rubio',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PRI',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/leslie-angelina-hendricks-rubio.png',
        },
      ],
      block: 'PRI',
      settings: {
        color: '#E40000',
      },
      election_key: 'infobae.com:mexico:quintana-roo:locales:governors:2022',
    },
  ],
};
//
//
//
//
//
//
//
//
//

const Tamaulipas = {
  parties: [
    {
      party_id: '3',
      votes: 0,
      votes_percent: 0.0,
      name: 'Juntos Hacemos Historia en Tamaulipas',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Américo Villarreal Anaya',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Morena, PT, PVEM',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/americo-villarreal-anaya.png',
        },
      ],
      block: 'Morena, PT, PVEM',
      settings: {
        color: '#B41F15',
      },
      election_key: 'infobae.com:mexico:tamaulipas:locales:governors:2022',
    },
    {
      party_id: '2',
      votes: 0,
      votes_percent: 0.0,
      name: 'Va por Tamaulipas',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'César Augusto Verástegui Ostos',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'PRI, PAN y PRD',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/cesar-augusto-verastegui-ostos.png',
        },
      ],
      block: 'PRI, PAN y PRD',
      settings: {
        color: '#D23026',
      },
      election_key: 'infobae.com:mexico:tamaulipas:locales:governors:2022',
    },
    {
      party_id: '1',
      votes: 0,
      votes_percent: 0.0,
      name: 'Movimiento Ciudadano',
      candidates: [
        {
          candidate_id: 'Gobernador',
          fullname: 'Arturo Díez Gutiérrez Navarro',
          votes: 0,
          votes_percent: 0.0,
          block_name: 'Movimiento Ciudadano',
          avatar: 'https://statics-ecp.infobae.com/2022/mexico/locales/img/avatars/arturo-diez-gutierrez-navarro.png',
        },
      ],
      block: 'Movimiento Ciudadano',
      settings: {
        color: '#ED6D12',
      },
      election_key: 'infobae.com:mexico:tamaulipas:locales:governors:2022',
    },
  ],
};

const JSONGobMex = { Aguascalientes, Durango, Hidalgo, Oaxaca, 'Quintana Roo': Quintana, Tamaulipas };

export default JSONGobMex;
